import { Layout } from "@/app/layout/Layout";
import { NotFound } from "@/app/notFound";
import { perfilRoutes } from "@/contexts/autorizacao/perfil";
import { usuarioPublicRoutes } from "@/contexts/autorizacao/usuario";
import { relatorioAMRoutes } from "@/contexts/fiscalizacao/relatorioAM";
import {
  termoNotificacaoPublicRoutes,
  termoNotificacaoRoutes,
} from "@/contexts/fiscalizacao/termoNotificacao";
import { homeRoutes } from "@/contexts/home";
import { analiseLaboratorialRoutes } from "@/contexts/laboratorio/analiseLaboratorial";
import { PageLoader } from "@/shared/components/PageLoader/PageLoader";
import { Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes as RoutesApp,
} from "react-router";

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export function Routes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <RoutesApp>
          <Route path="/" element={<Navigate to="/login" />} />
          {usuarioPublicRoutes()}
          {termoNotificacaoPublicRoutes()}

          <Route element={<LayoutRoute />}>
            {homeRoutes()}
            {analiseLaboratorialRoutes()}
            {termoNotificacaoRoutes()}
            {relatorioAMRoutes()}
            {perfilRoutes()}
          </Route>

          <Route path="*" element={<NotFound />} />
        </RoutesApp>
      </Suspense>
    </BrowserRouter>
  );
}
